export const NUMBER_OF_DISPLAY_CELLS = 24;
export const LOBOOK_EDIT_INTERVAL_MINUTES = 5;

export const calcNumberOfCols = (minInterval: number) =>
  (60 / minInterval) * 24;

export const NUMBER_OF_EDIT_COLS = calcNumberOfCols(
  LOBOOK_EDIT_INTERVAL_MINUTES
);

document.documentElement.style.setProperty(
  '--logbook-number-of-edit-cols',
  String(NUMBER_OF_EDIT_COLS)
);
